import { MUSCLE_TO_REGIONS, EXERCISE_CATALOGUE } from "./constants";

export const uid = () => Math.random().toString(36).slice(2, 9);
export const normalize = s => (s || "").toLowerCase().replace(/-/g, " ");
export const fmtWeight = (w, units = "lbs") => {
  if (!w && w !== 0) return "—";
  return units === "kg" ? Math.round(parseFloat(w) * 0.453592 * 10) / 10 : parseFloat(w);
};
export const fmtVol = (v, units = "lbs") =>
  units === "kg" ? Math.round(v * 0.453592) : Math.round(v);
export const wtLabel = (units = "lbs") => units === "kg" ? "KG" : "LBS";
export const today = () => new Date().toISOString().split("T")[0];
export const blankSet = () => ({ id: uid(), reps: "", weight: "", date: today() });
export const fmtDate = d => new Date(d + "T00:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
export const calcOrm = (w, r) => (!w || !r) ? null : Math.round(parseFloat(w) * (1 + parseInt(r) / 30));

export const weekStart = () => {
  const d = new Date(); d.setHours(0, 0, 0, 0);
  const day = d.getDay(); // 0=Sun … 6=Sat
  d.setDate(d.getDate() - ((day + 6) % 7)); // roll back to Monday
  return d.toISOString().split("T")[0];
};

export const weekEnd = () => {
  const d = new Date(weekStart() + "T00:00:00"); d.setDate(d.getDate() + 6);
  return d.toISOString().split("T")[0];
};

// Merges catalogue entries with user exercises; user exercises override catalogue entries
export function buildPool(userExercises) {
  const map = new Map();
  EXERCISE_CATALOGUE.forEach(e => map.set(e.name.toLowerCase(), {
    id: `cat__${e.name}`, name: e.name,
    muscles: e.muscles || [], category: e.category || "", source: "catalogue",
  }));
  userExercises.forEach(e => {
    map.set(e.name.toLowerCase(), {
      id: e.id, name: e.name,
      muscles: e.muscles || (e.muscle ? [e.muscle] : []),
      category: e.category || "", source: "mine",
    });
  });
  return [...map.values()];
}

export function buildIntensityMap(muscles = [], intensities = {}) {
  const map = {};
  muscles.forEach(m => {
    const level = intensities[m] || "high";
    const regions = MUSCLE_TO_REGIONS[m] || [];
    regions.forEach(r => { map[r] = level; });
  });
  return map;
}
